// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trans[data-v-0a899dbe] {\n  transition: background-color 0.3s, border-radius 0.3s, width 0.3s, height 0.3s;\n}\n.triangle[data-v-0a899dbe] {\n  width: 0;\n  height: 0;\n  border-top: 1rem solid transparent;\n  border-left: 2rem solid white;\n  border-bottom: 1rem solid transparent;\n}\n", ""]);
// Exports
module.exports = exports;
